"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWarehouse = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var Point_1 = require("./Point");
var ThirdPartyProviderActiveTime_1 = require("./ThirdPartyProviderActiveTime");
var WarehouseStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    status: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    shortName: (0, superstruct_1.string)(),
    isDistributionCenter: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    address: (0, superstruct_1.type)({
        latitude: (0, superstruct_1.number)(),
        longitude: (0, superstruct_1.number)(),
        streetName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
        postCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    }),
    /**
     * @deprecated use `promisedDeliveryTimeInMinutes` instead.
     */
    deliveryTimeInMinutes: (0, superstruct_1.number)(),
    promisedDeliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    polygonDeliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    throttledDeliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    polygonPoints: (0, superstruct_1.optional)((0, superstruct_1.array)(Point_1.PointStruct)),
    thirdPartyProviders: (0, superstruct_1.array)((0, superstruct_1.string)()),
    thirdPartyProviderActiveTimes: (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.array)(ThirdPartyProviderActiveTime_1.ThirdPartyProviderActiveTimeStruct))),
    isAutoAssignmentEnabled: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    isOrderStackingEnabled: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
});
function isWarehouse(obj) {
    return (0, isStruct_1.isStruct)(obj, WarehouseStruct, "Warehouse");
}
exports.isWarehouse = isWarehouse;
